import { authConfigs, defaultAuthConfig } from './constants'

export const getAuthRedirectUrl = (location) => {
  const domain = window.location.hostname.includes('elevatedliving.com')
    ? 'https://app.elevatedliving.com'
    : window.location.hostname.includes('redvike.rocks')
      ? 'https://elevatedliving.redvike.rocks'
      : 'http://localhost:3000'

  return `${domain}/#${location}`
}

export const getAuthConfig = (domain) => {
  const customLayout = authConfigs[domain]

  if (customLayout) {
    return customLayout
  }

  return defaultAuthConfig
}

export const validatePasswordInfo = (info) => {
  return info.symbolsAtLeast && info.upperCase && info.lowerCase && info.oneNumber
}

export const getLayoutBackgroundSettings = (isDefaultConfig) => {
  if (isDefaultConfig) {
    return {}
  }

  return {
    backgroundSize: 'contain',
    backgroundPosition: 'bottom right',
    backgroundColor: 'black',
    backgroundRepeat: 'no-repeat',
  }
}
